import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleRedirect.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleRedirect' */ './component')],
	render: ([AdminBicycleRedirect]) => <AdminBicycleRedirect />,
};

export default routes;
